import { lockBodyScroll, unlockBodyScroll } from "../../../../../src/js/body-scroll-lock.js";

function isLuigiSearchPage() {
	const params = new URLSearchParams(window.location.search);

	for (const key of params.keys()) {
		if (key === "lb.f[]" || key.startsWith("lb.f[")) {
			return true;
		}
	}

	return params.has("lb.q") || params.has("lb.query");
}

function focusLuigiSearch(event) {
	const trigger = event?.target?.closest?.(".open-search");
	if (!trigger) {
		return;
	}

	if (event && typeof event.preventDefault === "function") {
		event.preventDefault();
	}
	if (event && typeof event.stopImmediatePropagation === "function") {
		event.stopImmediatePropagation();
	}

	const searchOverlay = document.querySelector("#search-overlay");
	const searchOverlayBg = document.querySelector("#search-overlay-bg");
	if (searchOverlay) {
		searchOverlay.classList.add("open");
	}
	if (searchOverlayBg) {
		searchOverlayBg.classList.add("open");
	}
	lockBodyScroll("search");
	document.documentElement.classList.add("flux-search-is-open");
	document.body.classList.add("flux-search-is-open");

	const input = document.querySelector(
		[
			"#lb-search-element input[type='search']",
			"#lb-search-element input[type='text']",
			".lb-search input[type='search']",
			".lb-search input[type='text']",
			"#flux-search-input",
			".lb-input input[type='search']",
		].join(",")
	);

	if (!input) {
		return;
	}

	input.focus();
	input.click();
	input.dispatchEvent(new Event("input", { bubbles: true }));
}

function closeSearchOverlay() {
	const searchOverlay = document.querySelector("#search-overlay");
	const searchOverlayBg = document.querySelector("#search-overlay-bg");

	if (searchOverlay) {
		searchOverlay.classList.remove("open");
	}
	if (searchOverlayBg) {
		searchOverlayBg.classList.remove("open");
	}
	unlockBodyScroll("search");
	document.documentElement.classList.remove("flux-search-is-open");
	document.body.classList.remove("flux-search-is-open");
}

export function searchEvents() {
	if (isLuigiSearchPage()) {
		document.addEventListener("click", focusLuigiSearch, true);
		document
			.querySelector("#search-close")
			?.addEventListener("click", closeSearchOverlay);
		return;
	}

	const triggers = Array.from(document.querySelectorAll(".open-search"));
	if (!triggers.length) return;

	async function firstClick(e) {
		triggers.forEach((trigger) => trigger.removeEventListener("click", firstClick));
		try {
			const { initsearch } = await import("../../../search/orion/js/search.js");
			const opensearch = initsearch(triggers);
			if (typeof opensearch === "function") {
				opensearch(e);
			}
		} catch (err) {
			console.error("Failed to load module:", err);
		}
	}

	triggers.forEach((trigger) => trigger.addEventListener("click", firstClick));
}
